<template>
    <div class="wrapper" :style="{height: setting.autoCropHeight+1+'px', width: setting.autoCropWidth+1+'px'}">
        <vueCropper
            v-if="setting.img"
            ref="cropper"
            :img="setting.img"
            :outputType="options.outputType"
            :autoCrop="options.autoCrop"
            :autoCropWidth="setting.autoCropWidth"
            :autoCropHeight="setting.autoCropHeight"
            :fixed="options.fixed"
            :fixedNumber="options.fixedNumber"
            :fixedBox="options.fixedBox"
            :centerBox="options.centerBox"
            @imgLoad="getResult"
        ></vueCropper>
    </div>
</template>
<script>
export default {
    props: {
        setting: {
            type: Object,
            default: function(){
                return {
                    type: 1,    //1--封面图, 2---详情图
                    index: 0,
                    img: "",
                    autoCropWidth: 240,
                    autoCropHeight: 180,
                }
            }
        }
    },
    data(){
        return {
            options: {
                outputSize: 0.1,        //剪切后输出的图片质量
                outputType: "png",   //剪切后输出的图片格式
                canScale: true,       //是否允许滚轮缩放,
                autoCrop: true,       //是否默认生成截图框
                fixed: false,          //是否开启截图框固定宽度比例
                full: true,             //是否输入原图比例的截图
                fixedBox: false,       //固定截图框大小
                original: false,
                centerBox: true,      //截图框是否被限制在图片里面
                enlarge: 1,
            },
        }
    },
    methods: {
        getResult(){
            let w = this.$refs.cropper.cropW;
            let h = this.$refs.cropper.cropH;
            console.log(w);
            this.$refs.cropper.getCropData(data=>{
                this.$emit('getThumb',{url: data,index: this.setting.index || 0,type: this.setting.type || 1,width: w,height: h});
                this.$refs.cropper.refresh();
            })
        }
    }
}
</script>
<style scoped>
.wrapper{
    position: fixed;
    top: 0;
    left: 300px;
    opacity: 0;
    z-index: -999;
}
</style>



// WEBPACK FOOTER //
// src/components/common/createThumb.vue